import { apolloClient } from 'apollo-client';
import { GET_ACCOUNT_PAYMENT_METHODS } from 'pages/settings/secondary/payment-methods/payment-methods.api';
import { CREATE_PAYMENT_HOLD } from './create-payment-hold.api';

export type CreatePaymentHoldParams = {
  accountId: number;
  paymentMethodId: number;
  deletePaymentMethodOnFailure: boolean;
};

export type CreatePaymentHoldResponse = {
  result: `${PaymentHoldResult}`;
  message?: string;
};

export const createPaymentHold = async (
  params: CreatePaymentHoldParams
): Promise<CreatePaymentHoldResponse> => {
  const response = await apolloClient.mutate<
    CreatePaymentHoldMutation,
    CreatePaymentHoldMutationVariables
  >({
    mutation: CREATE_PAYMENT_HOLD,
    variables: { input: { ...params, amountCents: 100 } },
  });

  if (!response.data) throw new Error('Hold request failed');
  const { result, message } = response.data.createTemporaryPaymentHold;

  /*
    if the hold failed and we're deleting the payment on failure,
    refetch account payment methods to update the apollo cache
  */
  if (result !== 'success' && params.deletePaymentMethodOnFailure) {
    await apolloClient.query<
      GetAccountPaymentMethodsQuery,
      GetAccountPaymentMethodsQueryVariables
    >({
      query: GET_ACCOUNT_PAYMENT_METHODS,
      variables: { accountId: params.accountId },
      fetchPolicy: 'network-only',
    });
  }

  return { result, message: message || undefined };
};
